export default __webpack_public_path__ + "static/298-c84703927322853b97826209c1f551c7.gif";